import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getLetterboxRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {LetterBoxFilter, LetterBoxMenuTitles} from "root/DataFunctions/Constants";
import useModalAddLetterboxItem from "root/Modals/AddLetterboxItem/useModalAddLetterboxItem";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import LetterboxContext from "root/contexts/LetterboxContext";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const LetterboxSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const globals = useContext(GlobalContext);
    const letterboxContext = useContext( LetterboxContext ) ;

    // Open add resource modal
    const [renderAddLetterboxItemModal, showAddLetterboxItemModal] = useModalAddLetterboxItem((result) =>
    {
        // This refreshes the data with the previously stored query values
        letterboxContext.refreshLetterbox() ;
    })

    const clickHandler = (event) =>
    {
        showAddLetterboxItemModal('create', null, null);
    }

    const shouldShowForward = doesUserHaveApplication(ApplicationTypes.POSTBOX, globals.userType)  ;
    const shouldShowToApprove = doesUserHaveApplication(ApplicationTypes.POSTBOX_APPROVER, globals.userType)  ;
    const menuDefault = shouldShowToApprove ? LetterBoxFilter.UNAPPROVED : LetterBoxFilter.TO_SEND_ON;
    const letterbox_decision_filter = queryParams.type === undefined ?  menuDefault : queryParams.type;

    const getToApproveTitle = () =>{
        const title = shouldShowToApprove ? LetterBoxMenuTitles.UNAPPROVED : 'Waiting Approval';
        return title;
    }

    const letterboxSubmenu =() => {
        return (
            <AppSidebarGroup title='Filters' default={letterbox_decision_filter}>
                { shouldShowForward === true &&
                    <AppSidebarMenuItem
                        link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.TO_SEND_ON)}
                        title={LetterBoxMenuTitles.APPROVED} iconName='icon-arrow-right'
                        name={LetterBoxFilter.TO_SEND_ON}/> }

                <AppSidebarMenuItem link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.UNAPPROVED)}
                                    title={getToApproveTitle()} iconName='icon-important'
                                    name={LetterBoxFilter.UNAPPROVED}/>

                <AppSidebarMenuItem
                    link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.RETURNED_BY_LETTERBOX)}
                    title={LetterBoxMenuTitles.RETURNED} iconName='icon-question-circle'
                    name={LetterBoxFilter.RETURNED_BY_LETTERBOX}/>

                <AppSidebarMenuItem
                    link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.APPROVED)}
                    title={LetterBoxMenuTitles.SENT} iconName='icon-thumb-up'
                    name={LetterBoxFilter.APPROVED}/>

                <AppSidebarMenuItem
                    link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.NOT_APPROVED)}
                    title={LetterBoxMenuTitles.NOT_APPROVED} iconName='icon-thumbs-down'
                    name={LetterBoxFilter.NOT_APPROVED}/>

                    <AppSidebarMenuItem link={getLetterboxRouterLink('letterbox?type=' + LetterBoxFilter.ALL)}
                                        title={LetterBoxMenuTitles.ALL} iconName='icon-email' name={LetterBoxFilter.ALL}/>

                {shouldShowForward && <WieldySidebarSection title='New Letterbox Item' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Letterbox Item' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
                </WieldySidebarSection>}
            </AppSidebarGroup>
        )
    }

    return (
        <Fragment>
            { letterboxSubmenu ()}
            {renderAddLetterboxItemModal(props)}
        </Fragment>
    )
}

export default LetterboxSubmenu ;